<template>
  <div class="wrapper">
    <div style="width:300px">
      <el-form ref="form" :model="form" label-width="80px" width="300">
        <el-form-item :label="$t('balance')">
          <el-input v-model="form.balance" readonly></el-input>
        </el-form-item>
        <el-form-item :label="$t('topUp')">
          <el-input v-model="form.input" type="number"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="pay">
      <div class="pay-btn" @click="aliPay">{{$t('aliPay')}}</div>
      <div class="pay-btn" @click="wechatPay">{{$t('wechatPay')}}</div>
    </div>
    <template v-if="dialogPaymentShow">
      <Payment :codeImg="code_url" @clearInterPay="clearInterPay"></Payment>
    </template>
  </div>
</template>

<script>
import Payment from "@/components/payment.vue";
import { locationHost } from "@/config/env.js";
export default {
  components: { Payment },
  props: {},
  data() {
    return {
      dialogPaymentShow: false,
      code_url: "",
      form: {
        balance: "",
        input: ""
      },
      intervalPayStatus: ""
    };
  },
  watch: {},
  computed: {},
  methods: {
    getUserInfo() {
      this.$api.userInfo().then(res => {
        if (res.status) {
          this.userInfo = res.data;
          this.form.balance = res.data.balance;
          this.$storage.set("userInfo", res.data);
        }
      });
    },
    aliPay() {
      if (!this.form.input) {
        return this.$msg(this.$t('rechargeTips'), "warning");
      }
      let data = {
        ids: this.userInfo.id,
        payment_code: "alipay",
        payment_type: 2,
        params: {
          trade_type: "PC",
          money: this.form.input,
          return_url:
              locationHost+ "/#/center/balance"
        }
      };
      this.$api.pay(data).then(res => {
        if (res.status) {
          this.standarPost(res.data.url, res.data.data);
        }
      });
    },
    standarPost(url, data) {
      let tempForm = document.createElement("form");
      tempForm.id = "aliPay";
      tempForm.methods = "post";
      tempForm.action = url;
      tempForm.target = "_self";
      let input = [];
      for (let k in data) {
        input[k] = document.createElement("input");
        input[k].type = "hidden";
        input[k].name = k;
        input[k].value = data[k];
        tempForm.appendChild(input[k]);
      }
      tempForm.addEventListener("submit", function() {}, false);
      document.body.appendChild(tempForm);
      tempForm.dispatchEvent(new Event("submit"));
      tempForm.submit();
      document.body.removeChild(tempForm);
    },
    wechatPay() {
      if (!this.form.input) {
        return this.$msg(this.$t('rechargeTips'), "warning");
      }
      let data = {
        ids: this.userInfo.id,
        payment_code: "wechatpay",
        payment_type: 2,
        params: {
          trade_type: "NATIVE",
          money: this.form.input
        }
      };
      this.$api.pay(data).then(res => {
        if (res.status) {
          this.dialogPaymentShow = true;
          this.code_url = res.data.code_url;
          this.getPaymentStatus(res.data.payment_id);
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    getPaymentStatus(id) {
      let data = {
        payment_id: id
      };
      let that = this;
      this.intervalPayStatus = setInterval(function() {
        that.$api.paymentInfo(data).then(res => {
          if (res.status) {
            if (res.data.status == 2) {
              that.$msg(this.$t('success'));
              that.$router.go(-1);
            }
          }
        });
      }, 1000);
    },
    clearInterPay() {
      clearInterval(this.intervalPayStatus);
      this.dialogPaymentShow = false;
    }
  },
  created() {},
  mounted() {
    this.getUserInfo();
  },
  destroyed() {
    clearInterval(this.intervalPayStatus);
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.wrapper {
  .pay {
    display: flex;
    width: 300px;
    justify-content: space-around;
    padding-top: 20px;
    &-btn {
      width: 100px;
      height: 32px;
      line-height: 32px;
      background: $theme-color;
      color: #fff;
      text-align: center;
      margin-right: 20px;
      cursor: pointer;
    }
  }
}
</style>